// Example: src/pages/Home.js
import React from 'react';
import HeroSection from '../components/HeroSection';
import '../styles/gallery.css';

import Footer from '../components/Footer';
function Home() {
  return (
    <div>
      <HeroSection />
     
    </div>
  );
}

export default Home;
